import { render, staticRenderFns } from "./ScenariosCostsAnalysisChart.vue?vue&type=template&id=5e96a20d&scoped=true"
import script from "./ScenariosCostsAnalysisChart.vue?vue&type=script&lang=js"
export * from "./ScenariosCostsAnalysisChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96a20d",
  null
  
)

export default component.exports